import { useEffect, useState } from 'react';

// The build number comes from the server's VERSION file rather than the bundle,
// so a rebuilt frontend and a restarted server can never disagree about it.
let cached = null;

export function useAppVersion() {
  const [version, setVersion] = useState(cached);

  useEffect(() => {
    if (cached) return undefined;
    let live = true;
    fetch('/api/version')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!d || !d.version) return;
        cached = d.version;
        if (live) setVersion(d.version);
      })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  return version;
}
